import {COLORS} from '../../../../../constants/colors';
import {ColorItemLabelPosition} from './types';

export const getBorderColor = ({
  isActive,
  isLightColor,
}: {
  isActive: boolean;
  isLightColor: boolean;
}) => {
  if (isLightColor) {
    if (isActive) return COLORS.Black;

    return COLORS.Grey4;
  }

  return COLORS.White;
};

export const getCheckmarkColor = ({isLightColor}: {isLightColor: boolean}) => {
  if (isLightColor) {
    return COLORS.Black;
  }
  return COLORS.White;
};

export const getFlexDirection = (labelPosition: ColorItemLabelPosition) => {
  if (labelPosition === 'left' || labelPosition === 'top') return 'row-reverse';
  return 'row';
};

export const getFlexDirectionLegacy = (
  labelPosition: ColorItemLabelPosition,
) => {
  if (labelPosition === 'right') return 'row';
  if (labelPosition === 'left') return 'row-reverse';
  if (labelPosition === 'top') return 'column-reverse';
  return 'column';
};
